<script>
  import Accordion from './accordion.svelte';
  import BoasPraticas from './boaspraticas.svelte';
  import BoxGenerico from './boxgenerico.svelte';
  import CaisNaPratica from './caisnapratica.svelte';
  import Carousel from './carousel.svelte';
  import Citacao from './citacao.svelte';
  import Container from '../layout/container.svelte';
  import Destaque from './destaque.svelte';
  import DicaDeMidia from './dicademidia.svelte';
  import FlipCard from './flipcard.svelte';
  import Glossario from './glossario.svelte';
  import GlossarioHint from './glossariohint.svelte';
  import H1 from '../capa.svelte';
  import H2 from './h2.svelte';
  import H3 from './h3.svelte';
  import Image from './image.svelte';
  import JesusSlider from './jesusslider.svelte';
  import Lista from './lista.svelte';
  import P from './p.svelte';
  import ParaFixar from './parafixar.svelte';
  import Pergunta from './pergunta.svelte';
  import Podcast from './podcast.svelte';
  import Progress from './progress.svelte';
  import Referencias from './referencias.svelte';
  import SaibaMais from './saibamais.svelte';
  import Siglas from './siglas.svelte';
  import Sintese from './sintese.svelte';
  import SpaceY from './spacey.svelte';
  import Split from './split.svelte';
  import Tabs from './tabs.svelte';
  import TrechoNarrado from './trechonarrado.svelte';
  import Video from './video.svelte';

  import conteudo from '../../conteudo';
  import navegacaoStore from '../../store';

  import { onMount } from 'svelte';
  import { link, location } from 'svelte-spa-router';

  let cliente;
  let curso;
  let modulo;
  let setup_loaded = false;

  let dados = {
    ...conteudo,
  };

  navegacaoStore.subscribe((dadosStore) => {
    dados = dadosStore;
  });

  $: j$.getJSON('./assets/word/setup.json', function (data) {
    cliente = data.cliente;
    curso = data.curso;
    modulo = data.modulo;
    setup_loaded = true;
    navegacaoStore.update((dadosStore) => {
      return { ...dadosStore, cliente: cliente, curso: curso };
    });
  });

  $: if (setup_loaded) {
    j$.ajax({
      url: './assets/word/' + cliente + '_c' + curso + '_m' + modulo + '.xml',
      dataType: 'text',
      success: (texto) => {
        detectUnidade(texto);
      },
    });
  }

  let pageNumber;

  if ($location === '/' || Number($location.split('/')[1]) === 1) {
    pageNumber = 0;
  } else {
    pageNumber = Number($location.split('/')[1]) - 1;
  }
  let Component;

  function detectUnidade(arg) {
    let unidadeBegin;
    let unidadeEnd;
    let unidade;

    if (pageNumber != 0) {
      unidadeBegin = arg.search('<unidade' + pageNumber + '>');
      unidadeEnd = arg.search('</unidade' + pageNumber + '>');
      if (unidadeBegin != -1) {
        if (unidadeEnd != -1) {
          unidade = arg.substring(unidadeBegin + 10, unidadeEnd).trim();
          parse(unidade);
        }
      } else {
        unidadeBegin = arg.search('<referencias>');
        unidadeEnd = arg.search('</referencias>');
        if (unidadeBegin != -1) {
          if (unidadeEnd != -1) {
            unidade = arg.substring(unidadeBegin + 14, unidadeEnd).trim();
            parse(unidade);
          }
        }
      }
    } else {
      unidadeBegin = arg.search('<apresentacao>');
      unidadeEnd = arg.search('</apresentacao>');
      if (unidadeBegin != -1) {
        if (unidadeEnd != -1) {
          unidade = arg.substring(unidadeBegin + 15, unidadeEnd).trim();
          parse(unidade);
        }
      }
    }
  }

  let conteudoPlain;

  function remove(arg) {
    var div = document.createElement('div');
    div.innerHTML = arg.trim();

    div.innerHTML = div.innerHTML.replace(/&nbsp;/g, ' ');

    var data_p = div.innerHTML;

    var elements = div.children;

    while (elements[0]) {
      elements[0].parentNode.removeChild(elements[0]);
    }
    var repl = div.innerText;

    let lines = repl.split('\n');

    var i = 0;

    while (i < lines.length) {
      if (lines[i] != '' && lines[i] != ' ' && lines[i].trim().length != 0) {
        data_p = data_p.replace(lines[i], '<p>' + lines[i].trim() + '</p>');
      }

      i++;
    }

    return data_p;
  }

  function parse(datax) {
    var data = remove(datax);
    let conteudo;
    let conteudoClean;
    let componentName;
    let beginOpenMark;
    let endOpenMark;
    let beginCloseMark;
    let endCloseMark = 0;

    let index = 0;
    let auxIndex = 0;
    let auxConteudo;

    let componentCount = 0;

    const components = new Map([
      [['accordion', 0], Accordion],
      [['boaspraticas', 0], BoasPraticas],
      [['boxgenerico', 0], BoxGenerico],
      [['caisnapratica', 0], CaisNaPratica],
      [['carousel', 0], Carousel],
      [['citacao', 0], Citacao],
      [['destaque', 0], Destaque],
      [['dicademidia', 0], DicaDeMidia],
      [['flipcard', 0], FlipCard],
      [['glossariohint', 0], GlossarioHint],
      [['h1', 0], H1],
      [['h2', 0], H2],
      [['h3', 0], H3],
      [['imagem', 0], Image],
      [['jesusslider', 0], JesusSlider],
      [['lista', 0], Lista],
      [['p', 0], P],
      [['parafixar', 0], ParaFixar],
      [['pergunta', 0], Pergunta],
      [['podcast', 0], Podcast],
      [['progress', 0], Progress],
      [['saibamais', 0], SaibaMais],
      [['siglas', 0], Siglas],
      [['sintese', 0], Sintese],
      [['spacey', 0], SpaceY],
      [['split', 0], Split],
      [['tabs', 0], Tabs],
      [['trechonarrado', 0], TrechoNarrado],
      [['video', 0], Video],
    ]);

    conteudo = data;
    conteudo = conteudo.replace(/(\r\n|\n|\r)/gm, '');
    conteudo = conteudo.replace(/[\n\r\t]/gm, '');
    conteudo = conteudo.trim();

    conteudoPlain = conteudo;
    conteudoPlain = conteudoPlain.replace(/</g, '&lt;');
    conteudoPlain = conteudoPlain.replace(/>/g, '&gt;');

    do {
      auxConteudo = conteudo.substring(index, conteudo.length).trim();

      auxIndex = conteudo.substring(index, conteudo.length).length - auxConteudo.length;
      conteudo = conteudo.replace(
        conteudo.substring(index, conteudo.length),
        conteudo.substring(index, conteudo.length).trim()
      );

      beginOpenMark = conteudo.substring(index, conteudo.length).search('<');

      endOpenMark = conteudo.substring(index, conteudo.length).search('>');
      componentName = conteudo
        .substring(index, conteudo.length)
        .substring(beginOpenMark + 1, endOpenMark)
        .trim();

      if (beginOpenMark != -1) {
        beginCloseMark = conteudo
          .substring(index, conteudo.length)
          .search('</' + componentName + '>');

        endCloseMark = beginCloseMark + 2 + componentName.length;

        // ----- Instantiate components -----
        for (var [name, component] of components) {
          if (componentName == name[0]) {
            if (beginCloseMark != -1) {
              conteudoClean = conteudo
                .substring(index, conteudo.length)
                .substring(beginOpenMark + componentName.length + 2, beginCloseMark);
              Component = component;

              name[1]++;

              new Component({
                target: document.querySelector('#viewer'),
                props: {
                  content: conteudoClean,
                  idUnico: componentName + '-' + pageNumber + '-' + name[1],
                },
              });
              break;
            }
          }
        }

        index = index + endCloseMark + 1;
      }
    } while (index < conteudo.length);
  }
</script>

<div id="viewer"></div>
